export default __webpack_public_path__ + "static/media/oneofzero-marked.14782359.png";